import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Layout,
  Drawer,
  Button,
  Input,
  Tooltip,
} from "antd";

import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  BarChartOutlined,
  CalendarOutlined,
  TeamOutlined,
  ReadOutlined,
  DollarOutlined,
  SettingOutlined,
  UsergroupAddOutlined,
  SearchOutlined,
  WalletOutlined,
  CreditCardOutlined,
  UserAddOutlined,
  SafetyCertificateOutlined,
  SolutionOutlined,
  ApartmentOutlined,
  BookOutlined,
  FileTextOutlined,
  FileSearchOutlined,
  PaperClipOutlined,
  CheckCircleOutlined,
  TrophyOutlined,
  LineChartOutlined,
  FileDoneOutlined,
  PieChartOutlined,
  IdcardOutlined,
  AccountBookOutlined,
  CheckSquareOutlined,
  CloseOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import {
  FaClipboardList,
  FaReceipt,
  FaGraduationCap,
  FaChalkboardTeacher,
} from "react-icons/fa";

import { motion } from "framer-motion";

// Financial
import SchoolFinancialReport from "../SchoolDashApp/SchoolFinancialReport";
import IncomeStatement from "../SchoolDashApp/IncomeStatement";
import SchoolFeeDataChart from "../SchoolDashApp/SchoolFeeDataChart";

// Smart ID Cards
import TeacherAttendanceScanner from "./SmartIDCardScaner/TeacherAttendanceScanner";
import TeacherSmartCardManagement from "./SmartIDCardScaner/TeacherSmartCardManagement";
import TeacherScannerDeviceManagement from "./SmartIDCardScaner/TeacherScannerDeviceManagement";
import TeacherSmartAttendanceDashboard from "./SmartIDCardScaner/TeacherSmartAttendanceDashboard";

// Todo
import PostTodoList from "./CalenderAndTodo/PostTodoList";

// Teachers
import PrintTestByClass from "../pages/Teachers/PrintTestByClass";
import ViewLessonPlan from "../pages/Teachers/ViewLessonPlan";

// Dashboard
import Overview from "./pages/Overview";

// User
import UserSearchBox from "../SchoolDashApp/UserDetails/UserSearchBox";
import UserDetailsPage from "../SchoolDashApp/UserDetails/UserDetailsPage";
import ProfileImage from "./ProfileImage";

// Students
import AddStudentsStaff from "./NewStudents/AddStudentsStaff";
import AdmissionForm from "./NewStudents/AdmissionForm/AdmissionForm";
import StudentAdmission from "./NewStudents/AdmissionForm/StudentAdmission";

// Results
import GradeDistribution from "../pages/Reportcard/GradeDistribution";
import ReportCard from "./ReportCard";
import PromotionDashboard from "./AcademyYearSelection/PromotionDashboard";

// Academic
import ClassViewList from "../SchoolDashApp/Class/ClassViewList";
// import SubjectViewList from "../SchoolDashApp/Class/Subjects/SubjectViewList";
import ViewCourses from "../SchoolDashApp/Class/Subjects/ViewCourses";
import ApprovedLearningCourse from "./AdminApproveCource/ApprovedLearningCourse";

// Staff
import TeacherDataForm from "../pages/Teachers/TeacherDataForm";
import SupportStaff from "../pages/Teachers/SupportStaff";

// Attendance
import AttendanceRecord from "../pages/Attendance/AttendanceRecord";
import AttendanceData from "../pages/Attendance/AttendanceData";

// Finance
import FinanceDashboard from "../pages/FinancialReports/FinanceDashboard";
import HighAveragesPage from "../SchoolDashApp/ReportCard/HighAveragesPage";
import StudentStatusSummary from "../SchoolDashApp/StudentStatusSummary";
import PeriodReport from "../pages/Reportcard/PeriodReport";
import BulkTestScorePage from "../SchoolDashApp/ReportCard/BulkTestScorePage";
import TopStudentPerPeriod from "../SchoolDashApp/ReportCard/TopStudentPerPeriod";
import Loan from "../pages/FinancialReports/Loan";
import FinancialPaymentRecord from "../SchoolDashApp/FinancialPaymentRecord";
import OtherFee from "../pages/FinancialReports/OtherFee";
import PaymentRecord from "../SchoolDashApp/PaymentRecord";
import SchoolFeesData from "../SchoolDashApp/SchoolFeesData";
import OtherFeesPayment from "../SchoolDashApp/OtherFeesPayment";
import MonthlyFinancialRecord from "../pages/FinancialReports/MonthlyFinancialRecord";
import DashboardForExpenditure from "./DashboardForExpenditure";
import Payroll from "../pages/Teachers/Payroll";

// Teaching
import AssignmentView from "../pages/Teachers/AssignmentView";
import GetStudentNotes from "../pages/Teachers/GetStudentNotes";
import TestPraint from "../pages/Teachers/TestPraint";
import TestAttachmentView from "../SchoolDashApp/TestAttachmentView";

// Student services
import CertificateDashboard from "./certificate/CertificateDashboard";
import StudentsIDCard from "../pages/Students/IdCards/StudentsIDCard";
import DailyPaymentTransaction from "../SchoolDashApp/DailyTransaction/DailyPaymentTransaction";
import StudentPaymentHistory from "../SchoolDashApp/DailyTransaction/StudentPaymentHistory";

// Other
import SchoolArchiveDashboard from "./SchoolArchiveDashboard";
import Darkmode from "./Darkmode/Darkmode";
import NotificationIcon from "../components/ChatApp/NotificationIcon";
import Notice from "../components/ChatApp/Notice";
import ComplaintUnit from "../Dashboard/ComplaintUnit";
import NewBlackList from "./NewBlackList";

// Academic Year
import AddAcademyYear from "./AcademyYearSelection/AddAcademyYear";

// Curriculum
import CurriculumAdminUpload from "./CurriculumAdminUpload";

import logo from "./cayeplogo.jpg";

const { Header, Sider, Content } = Layout;

const COLORS = {
  primary: "#0F5B78",
  primaryDark: "#0B465D",
  secondary: "#365B6D",

  page: "#F4F7F9",
  pureWhite: "#FFFFFF",

  text: "#172B3A",
  muted: "#647482",
  border: "#DCE4E8",
  soft: "#F8FAFB",

  success: "#16805C",
  warning: "#C88719",
  error: "#C44545",
  info: "#2778A8",

  sidebar: "#07161D",
  sidebarAlt: "#0B2029",
  sidebarBorder: "#183844",

  sidebarText: "#D9E7EC",
  sidebarMuted: "#8FA8B3",
  sidebarIcon: "#8FB8C8",
  sidebarBright: "#63C5E6",

  gold: "#C88719",
  yellow: "#D49A27",
  orange: "#C88719",
  green: "#16805C",
  sky: "#2778A8",
  antique: "#7893A0",

  black: "#07161D",
  white: "#F4F8FA",
  gray: "#A8BAC2",

  shadow:
    "0 12px 35px rgba(15,43,56,.08)",
};

const menuItems = [
  {
    key: "overview",
    icon: <DashboardOutlined />,
    label: "Dashboard",
  },
  {
    key: "incomestatement",
    icon: <DashboardOutlined />,
    label: "Income Statement",
  },
  {
    key: "feesrecord",
    icon: <DollarOutlined />,
    label: "Fees Record",
  },
  {
    key: "classfees",
    icon: <FaGraduationCap />,
    label: "Class Fees",
  },
  {
    key: "schoolfeedatachart",
    icon: <FaGraduationCap />,
    label: "Class Fees Record Chart",
  },
  {
    key: "feesrecordanalysics",
    icon: <DollarOutlined />,
    label: "Fees Record Analysics",
  },
  {
    key: "newexpenditure",
    icon: <DollarOutlined />,
    label: "New Expenditure",
  },
  {
    key: "dailytransaction",
    icon: <DashboardOutlined />,
    label: "Daily Transaction",
  },
  {
    key: "studentpaymentistory",
    icon: <DashboardOutlined />,
    label: "Students Transaction History",
  },
  {
    key: "studentsadmission",
    icon: <UsergroupAddOutlined />,
    label: "Students Admission",
  },
  {
    key: "admissionlist",
    icon: <TeamOutlined />,
    label: "Students List",
  },
  // {
  //   key: "promotion",
  //   icon: <UserAddOutlined />,
  //   label: "Promotion",
  // },
  {
    key: "studentscertificate",
    icon: <SafetyCertificateOutlined />,
    label: "Students Certificate",
  },
  {
    key: "studentsidcards",
    icon: <IdcardOutlined />,
    label: "Generate ID Cards",
  },
  {
    key: "complaintunit",
    icon: <IdcardOutlined />,
    label: "Manage Students Complain",
  },
  {
    key: "statusrecord",
    icon: <SolutionOutlined />,
    label: "Students Status Record",
  },
  {
    key: "classviewlist",
    icon: <ApartmentOutlined />,
    label: "Grade Classes",
  },

      {
    key: "approvedlearningcourse",
    icon: <BookOutlined />,
    label: "Approved Learning Course",
  },

  {
    key: "subjectviewlist",
    icon: <BookOutlined />,
    label: "Courses Listing",
  },



  {
    key: "schoolarchivedashboard",
    icon: <FaChalkboardTeacher />,
    label: "School Archive Dashboard",
  },
  {
    key: "teacherdata",
    icon: <FaChalkboardTeacher />,
    label: "Teacher Data",
  },
  // {
  //   key: "viewlessonplan",
  //   icon: <FaChalkboardTeacher />,
  //   label: "View Teacher Lesson Plans",
  // },
  // {
  //   key: "supportstaff",
  //   icon: <TeamOutlined />,
  //   label: "Support Staff Data",
  // },
  // {
  //   key: "getteachernotes",
  //   icon: <FileTextOutlined />,
  //   label: "Teacher Notes",
  // },
  // {
  //   key: "testprint",
  //   icon: <FileSearchOutlined />,
  //   label: "Teacher Test",
  // },
  // {
  //   key: "printtestbyclass",
  //   icon: <FileDoneOutlined />,
  //   label: "Print Test By Class",
  // },
  // {
  //   key: "testattachmentview",
  //   icon: <PaperClipOutlined />,
  //   label: "Test File or Attachment",
  // },
  // {
  //   key: "studentsassignments",
  //   icon: <FaClipboardList />,
  //   label: "Students Assignments",
  // },
  // {
  //   key: "studentsnotes",
  //   icon: <ReadOutlined />,
  //   label: "Students Notes",
  // },
  // {
  //   key: "attendancerecord",
  //   icon: <CheckCircleOutlined />,
  //   label: "Attendance Record",
  // },

  // {
  //   key: "gradedistribution",
  //   icon: <PieChartOutlined />,
  //   label: "Grades Distribution",
  // },

  // {
  //   key: "bulkgrades",
  //   icon: <FaChalkboardTeacher />,
  //   label: "Bulk Grades",
  // },
  // {
  //   key: "topstudents",
  //   icon: <TrophyOutlined />,
  //   label: "Top Students",
  // },
  // {
  //   key: "highaverages",
  //   icon: <LineChartOutlined />,
  //   label: "High Yearly Averages",
  // },
  // {
  //   key: "periodicreport",
  //   icon: <FileDoneOutlined />,
  //   label: "Periodic Report",
  // },
  // {
  //   key: "reportcard",
  //   icon: <FileTextOutlined />,
  //   label: "Report Card",
  // },
  {
    key: "financedashboard",
    icon: <BarChartOutlined />,
    label: "Semester Fees Summary",
  },
  {
    key: "feesallocation",
    icon: <AccountBookOutlined />,
    label: "Fees Allocation",
  },
  {
    key: "otherfees",
    icon: <FaReceipt />,
    label: "Other Fees",
  },

  {
    key: "monthlyrecords",
    icon: <CalendarOutlined />,
    label: "Monthly Records",
  },

  {
    key: "payroll",
    icon: <WalletOutlined />,
    label: "Payroll Management",
  },
  {
    key: "systemusers",
    icon: <UsergroupAddOutlined />,
    label: "Add System Users",
  },
  {
    key: "newblacklist",
    icon: <FaChalkboardTeacher />,
    label: "Secure",
  },
  {
    key: "teachersmartattendancedashboard",
    icon: <FaChalkboardTeacher />,
    label: "Monitor Teacher Attendance",
  },
  {
    key: "teacherattendancescanner",
    icon: <FaChalkboardTeacher />,
    label: "Teacher Attendance Scanner",
  },
  {
    key: "teachersmartcardmanagement",
    icon: <FaChalkboardTeacher />,
    label: "Teacher Card Management",
  },
  {
    key: "teacherscannerdevicemanagement",
    icon: <FaChalkboardTeacher />,
    label: "Teacher Scanner Device Management",
  },
  {
    key: "curriculumadminupload",
    icon: <FaChalkboardTeacher />,
    label: "Curriculum Admin Upload",
  },
  {
    key: "settings",
    icon: <SettingOutlined />,
    label: "Settings",
  },
];

const navigationSections = [
  {
    key: "command",
    title: "COMMAND CENTER",
    items: ["overview", "analytics"],
  },
  {
    key: "finance",
    title: "FINANCE & OPERATIONS",
    items: [
      "incomestatement",
      "feesrecord",
      "classfees",
      "schoolfeedatachart",
      "feesrecordanalysics",
      "newexpenditure",
      "dailytransaction",
      "studentpaymentistory",
      "financedashboard",
      "feesallocation",
      "otherfees",
      "cleararrears",
      "monthlyrecords",
      "loan",
      "payroll",
    ],
  },
  {
    key: "learners",
    title: "LEARNER MANAGEMENT",
    items: [
      "studentsadmission",
      "admissionlist",
      "promotion",
      "studentscertificate",
      "studentsidcards",
      "complaintunit",
      "statusrecord",
    ],
  },
  {
    key: "academic",
    title: "ACADEMIC ADMINISTRATION",
    items: [
      "classviewlist",
      "subjectviewlist",
      "approvedlearningcourse",
      "gradedistribution",
      "bulkgrades",
      "topstudents",
      "highaverages",
      "periodicreport",
      "reportcard",
    ],
  },
  {
    key: "faculty",
    title: "FACULTY & STAFF",
    items: [
      "schoolarchivedashboard",
      "teacherdata",
      "viewlessonplan",
      "supportstaff",
      "getteachernotes",
      "attendancerecord",
      "attendancedata",
    ],
  },
  {
    key: "learning",
    title: "TEACHING & LEARNING",
    items: [
      "testprint",
      "printtestbyclass",
      "testattachmentview",
      "studentsassignments",
      "studentsnotes",
    ],
  },
  {
    key: "security",
    title: "SECURITY & DEVICES",
    items: [
      "newblacklist",
      "teachersmartattendancedashboard",
      "teacherattendancescanner",
      "teachersmartcardmanagement",
      "teacherscannerdevicemanagement",
    ],
  },
  {
    key: "administration",
    title: "SYSTEM ADMINISTRATION",
    items: [
      "systemusers",
      "curriculumadminupload",
      "settings",
    ],
  },
];

const NewAdminDashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [activePage, setActivePage] = useState("overview");
  const [selectedUser, setSelectedUser] = useState(null);
  const [menuSearch, setMenuSearch] = useState("");
  const [todoOpen, setTodoOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined"
      ? window.innerWidth < 900
      : false
  );

  const [isNavigating, setIsNavigating] =
    useState(false);

  const [pendingPage, setPendingPage] =
    useState(null);

  const [openAcademyYear, setOpenAcademyYear] =
    useState(false);

  const [academyYearRefreshing, setAcademyYearRefreshing] =
    useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 900;

      setIsMobile(mobile);

      if (mobile) {
        setCollapsed(false);
      }
    };

    handleResize();

    window.addEventListener(
      "resize",
      handleResize
    );

    return () => {
      window.removeEventListener(
        "resize",
        handleResize
      );
    };
  }, []);

  useEffect(() => {
    const style = document.createElement("style");

    style.id =
      "cayep-leadership-dashboard-styles";

    style.innerHTML = `
      * {
        box-sizing: border-box;
      }

      html,
      body,
      #root {
        margin: 0;
        min-height: 100%;
      }

      body {
        overflow: hidden;
        background: #F4F7F9;
        color: #172B3A;
      }

      ::-webkit-scrollbar {
        width: 7px;
        height: 7px;
      }

      ::-webkit-scrollbar-track {
        background: transparent;
      }

      ::-webkit-scrollbar-thumb {
        background: #9DB2BC;
        border-radius: 20px;
      }

      ::-webkit-scrollbar-thumb:hover {
        background: #0F5B78;
      }

      * {
        scrollbar-width: thin;
        scrollbar-color:
          #9DB2BC
          transparent;
      }

      .college-menu-button {
        width: 39px !important;
        height: 39px !important;
        min-width: 39px !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        border-radius: 9px !important;
        border: 1px solid #DCE4E8 !important;
        background: #FFFFFF !important;
        color: #365B6D !important;
        box-shadow: none !important;
      }

      .college-menu-button:hover {
        color: #0F5B78 !important;
        border-color: #9FC4D2 !important;
        background: #EEF6F9 !important;
      }

      .college-dark .college-menu-button {
        background: #14262E !important;
        border-color: #284651 !important;
        color: #D9E7EC !important;
      }

      .college-search-box
      .ant-input-affix-wrapper {
        min-height: 39px !important;
        border-radius: 9px !important;
        border: 1px solid #DCE4E8 !important;
        background: #FFFFFF !important;
        box-shadow: none !important;
      }

      .college-search-box
      .ant-input-affix-wrapper:hover {
        border-color: #9FC4D2 !important;
      }

      .college-search-box
      .ant-input-affix-wrapper-focused {
        border-color: #0F5B78 !important;
        box-shadow:
          0 0 0 2px rgba(15,91,120,.10) !important;
      }

      .college-search-box
      .ant-input {
        color: #172B3A !important;
      }

      .college-search-box
      .ant-input::placeholder {
        color: #81919B !important;
      }

      .college-dark
      .college-search-box
      .ant-input-affix-wrapper {
        background: #14262E !important;
        border-color: #284651 !important;
      }

      .college-dark
      .college-search-box
      .ant-input {
        color: #F3F8FA !important;
      }

      .college-sidebar-search
      .ant-input-affix-wrapper {
        min-height: 39px !important;
        border-radius: 8px !important;
        background: #0D232C !important;
        border: 1px solid #244550 !important;
        box-shadow: none !important;
      }

      .college-sidebar-search
      .ant-input-affix-wrapper:hover {
        border-color: #377A91 !important;
      }

      .college-sidebar-search
      .ant-input {
        background: transparent !important;
        color: #E4F0F4 !important;
      }

      .college-sidebar-search
      .ant-input::placeholder {
        color: #78939E !important;
      }

      .college-sidebar-search
      .ant-input-affix-wrapper-focused {
        border-color: #0F5B78 !important;
        box-shadow:
          0 0 0 2px rgba(15,91,120,.18) !important;
      }

      .college-sidebar-scroll {
        scrollbar-width: thin;
        scrollbar-color:
          #294955
          transparent;
      }

      .college-section-title {
        padding:
          16px 18px 7px;
        color: #6F8C99;
        font-size: 9px;
        font-weight: 800;
        letter-spacing: 1.25px;
        user-select: none;
      }

      .college-nav-item {
        position: relative;
        width: calc(100% - 24px);
        min-height: 43px;
        margin: 2px 12px;
        padding: 0 12px;
        border: 0;
        border-radius: 8px;
        display: flex;
        align-items: center;
        gap: 11px;
        color: #C7D8DE;
        background: transparent;
        cursor: pointer;
        text-align: left;
        font-family: inherit;
        font-size: 13px;
        font-weight: 500;
        transition:
          background 150ms ease,
          color 150ms ease,
          transform 150ms ease;
      }

      .college-nav-item:hover {
        background:
          linear-gradient(
            90deg,
            rgba(15,91,120,.30),
            rgba(15,91,120,.10)
          );
        color: #FFFFFF;
      }

      .college-nav-item:hover
      .college-nav-icon {
        color: #63C5E6;
        border-color:
          rgba(99,197,230,.20);
        background:
          rgba(99,197,230,.08);
      }

      .college-nav-item.active {
        background:
          linear-gradient(
            90deg,
            rgba(15,91,120,.58),
            rgba(15,91,120,.25)
          );
        color: #FFFFFF;
        font-weight: 700;
        box-shadow:
          0 6px 18px rgba(0,0,0,.18);
      }

      .college-nav-item.active::before {
        content: "";
        position: absolute;
        left: 0;
        top: 8px;
        bottom: 8px;
        width: 3px;
        border-radius: 0 3px 3px 0;
        background: #63C5E6;
        box-shadow:
          0 0 10px rgba(99,197,230,.55);
      }

      .college-nav-item.active
      .college-nav-icon {
        color: #63C5E6;
        border-color:
          rgba(99,197,230,.25);
        background:
          rgba(99,197,230,.10);
      }

      .college-nav-icon {
        width: 28px;
        height: 28px;
        min-width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 7px;
        color: #8FB8C8;
        border: 1px solid transparent;
        font-size: 15px;
        transition: all 150ms ease;
      }

      .college-nav-label {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 1.2;
      }

      .college-nav-chevron {
        margin-left: auto;
        opacity: 0;
        transform: translateX(-3px);
        transition: all 150ms ease;
        color: #63C5E6;
      }

      .college-nav-item:hover
      .college-nav-chevron,
      .college-nav-item.active
      .college-nav-chevron {
        opacity: 1;
        transform: translateX(0);
      }

      .college-collapsed-item {
        width: calc(100% - 18px);
        justify-content: center;
        margin-left: 9px;
        margin-right: 9px;
        padding: 0;
      }

      .college-collapsed-item
      .college-nav-chevron {
        display: none;
      }

      .college-collapsed-item
      .college-nav-label {
        display: none;
      }

      .college-collapsed-item
      .college-nav-icon {
        width: 34px;
        height: 34px;
        min-width: 34px;
      }

      .college-header-action {
        width: 39px;
        height: 39px;
        min-width: 39px;
        padding: 0;
        border-radius: 9px;
        border: 1px solid #DCE4E8;
        background: #FFFFFF;
        color: #365B6D;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 160ms ease;
      }

      .college-header-action:hover {
        color: #0F5B78;
        border-color: #9FC4D2;
        background: #EEF6F9;
      }

      .college-dark
      .college-header-action {
        background: #14262E;
        border-color: #284651;
        color: #D9E7EC;
      }

      .college-academic-year {
        height: 39px;
        padding: 0 13px;
        border-radius: 9px;
        border: 1px solid #DCE4E8;
        background: #FFFFFF;
        color: #365B6D;
        display: flex;
        align-items: center;
        gap: 7px;
        cursor: pointer;
        font-size: 11px;
        font-weight: 700;
        white-space: nowrap;
        transition: all 160ms ease;
      }

      .college-academic-year:hover {
        color: #0F5B78;
        border-color: #9FC4D2;
        background: #EEF6F9;
      }

      .college-academic-year:disabled {
        opacity: .65;
        cursor: not-allowed;
      }

      .college-dark
      .college-academic-year {
        background: #14262E;
        border-color: #284651;
        color: #D9E7EC;
      }

      .college-profile-container {
        width: 40px;
        height: 40px;
        min-width: 40px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #0F5B78;
        background: #FFFFFF;
        box-shadow:
          0 3px 12px rgba(15,43,56,.14);
        position: relative;
      }

      .college-profile-avatar {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border-radius: 50%;
      }

      .college-profile-container > *,
      .college-profile-avatar > * {
        width: 100% !important;
        height: 100% !important;
        min-width: 0 !important;
        min-height: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      .college-profile-container img,
      .college-profile-avatar img {
        width: 100% !important;
        height: 100% !important;
        min-width: 100% !important;
        min-height: 100% !important;
        object-fit: cover !important;
        object-position: center !important;
        display: block !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .college-workspace {
        border: 1px solid #DCE4E8;
        background: #FFFFFF;
        border-radius: 11px;
        min-height: calc(100vh - 111px);
        box-shadow:
          0 4px 18px rgba(15,43,56,.035);
      }

      .college-workspace-dark {
        background: #14262E;
        border-color: #284651;
      }

      .college-navigation-progress {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        z-index: 1000;
        overflow: hidden;
        background: rgba(15,91,120,.12);
      }

      .college-navigation-progress::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        background: #0F5B78;
        box-shadow:
          0 0 8px rgba(15,91,120,.45);
        animation:
          collegeNavigationProgress
          3s linear forwards;
      }

      @keyframes collegeNavigationProgress {
        0% {
          width: 0%;
        }

        15% {
          width: 22%;
        }

        45% {
          width: 48%;
        }

        70% {
          width: 70%;
        }

        90% {
          width: 88%;
        }

        100% {
          width: 100%;
        }
      }

      .college-loading-label {
        position: absolute;
        top: 11px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1001;
        padding: 5px 10px;
        border-radius: 6px;
        background: rgba(7,22,29,.96);
        color: #FFFFFF;
        font-size: 9px;
        font-weight: 700;
        letter-spacing: .75px;
        text-transform: uppercase;
        white-space: nowrap;
        box-shadow:
          0 5px 15px rgba(0,0,0,.18);
      }

      .college-page-heading {
        min-height: 34px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-bottom: 8px;
        padding: 0 2px;
      }

      .college-page-heading-left {
        min-width: 0;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .college-page-heading-line {
        width: 4px;
        height: 18px;
        min-width: 4px;
        border-radius: 3px;
        background: #0F5B78;
        box-shadow:
          0 0 7px rgba(15,91,120,.22);
      }

      .college-page-heading-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #172B3A;
        font-size: 14px;
        font-weight: 750;
      }

      .college-dark
      .college-page-heading-title {
        color: #F3F8FA;
      }

      .college-page-heading-meta {
        color: #647482;
        font-size: 10px;
        font-weight: 600;
        white-space: nowrap;
        letter-spacing: .2px;
      }

      .college-dark
      .college-page-heading-meta {
        color: #9FB5BF;
      }

      .college-dark {
        color: #F3F8FA;
      }

      .college-dark .college-sidebar-search
      .ant-input-affix-wrapper {
        background: #0D232C !important;
        border-color: #284651 !important;
      }

      .college-dark .college-sidebar-search
      .ant-input {
        color: #F3F8FA !important;
      }

      .college-dark .college-sidebar-search
      .ant-input::placeholder {
        color: #78939E !important;
      }

      .college-dark .college-nav-item {
        color: #C7D8DE;
      }

      .college-dark .college-nav-item:hover {
        background:
          linear-gradient(
            90deg,
            rgba(15,91,120,.34),
            rgba(15,91,120,.12)
          );
        color: #FFFFFF;
      }

      .college-dark .college-nav-item.active {
        background:
          linear-gradient(
            90deg,
            rgba(15,91,120,.62),
            rgba(15,91,120,.26)
          );
        color: #FFFFFF;
      }

      .college-dark .college-section-title {
        color: #6F8C99;
      }

      .college-dark .college-page-heading-line {
        background: #63C5E6;
      }

      .college-sidebar-shell {
        position: relative;
        overflow: hidden;
        background:
          linear-gradient(
            145deg,
            #07161D 0%,
            #091B23 45%,
            #07161D 100%
          );
      }

      .college-sidebar-shell::before {
        content: "";
        position: absolute;
        inset: -40%;
        pointer-events: none;
        background:
          repeating-linear-gradient(
            118deg,
            transparent 0,
            transparent 72px,
            rgba(48,148,177,.045) 73px,
            rgba(48,148,177,.045) 75px,
            transparent 76px,
            transparent 145px
          );
        animation:
          collegeSidebarStripes
          24s linear infinite;
        transform: translate3d(0,0,0);
      }

      .college-sidebar-shell::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 1px;
        pointer-events: none;
        background:
          linear-gradient(
            180deg,
            rgba(99,197,230,.10),
            rgba(99,197,230,.45),
            rgba(99,197,230,.08)
          );
        box-shadow:
          0 0 18px rgba(99,197,230,.10);
      }

      .college-sidebar-content {
        position: relative;
        z-index: 2;
        height: 100%;
      }

      @keyframes collegeSidebarStripes {
        0% {
          transform:
            translate3d(-45px,-20px,0)
            rotate(0deg);
        }

        50% {
          transform:
            translate3d(45px,20px,0)
            rotate(1deg);
        }

        100% {
          transform:
            translate3d(-45px,-20px,0)
            rotate(0deg);
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .college-sidebar-shell::before {
          animation: none;
        }
      }

      @media (max-width: 899px) {
        .college-academic-year {
          width: 39px;
          padding: 0;
          justify-content: center;
        }

        .college-academic-year-text {
          display: none;
        }

        .college-profile-container {
          width: 36px;
          height: 36px;
          min-width: 36px;
        }

        .college-workspace {
          min-height: calc(100vh - 96px);
          border-radius: 8px;
        }

        .college-page-heading {
          min-height: 30px;
        }

        .college-page-heading-title {
          font-size: 13px;
        }

        .college-page-heading-meta {
          display: none;
        }
      }

      @media (max-width: 560px) {
        .college-header-action {
          width: 36px;
          height: 36px;
          min-width: 36px;
        }

        .college-menu-button {
          width: 36px !important;
          height: 36px !important;
          min-width: 36px !important;
        }

        .college-profile-container {
          width: 34px;
          height: 34px;
          min-width: 34px;
        }

        .college-workspace {
          border-left: 0;
          border-right: 0;
          box-shadow: none;
        }
      }
    `;

    document.head.appendChild(style);

    return () => {
      const existing =
        document.getElementById(
          "cayep-leadership-dashboard-styles"
        );

      if (existing) {
        existing.remove();
      }
    };
  }, []);

  const theme = useMemo(
    () => ({
      darkMode,

      background: darkMode
        ? "#09171E"
        : COLORS.page,

      sidebar: darkMode
        ? COLORS.sidebar
        : COLORS.sidebar,

      header: darkMode
        ? "#10232C"
        : COLORS.pureWhite,

      card: darkMode
        ? "#14262E"
        : COLORS.pureWhite,

      inputBackground: darkMode
        ? "#14262E"
        : COLORS.pureWhite,

      text: darkMode
        ? "#F3F8FA"
        : COLORS.text,

      secondary: darkMode
        ? "#9FB5BF"
        : COLORS.muted,

      border: darkMode
        ? "#284651"
        : COLORS.border,

      primary: COLORS.primary,
      navy: COLORS.sidebar,
      blue: COLORS.secondary,
      gold: COLORS.gold,
      yellow: COLORS.yellow,
      orange: COLORS.orange,
      green: COLORS.green,
      sky: COLORS.sky,
      antique: COLORS.antique,
    }),
    [darkMode]
  );

  const menuLookup = useMemo(
    () =>
      Object.fromEntries(
        menuItems.map((item) => [
          item.key,
          item,
        ])
      ),
    []
  );

  const filteredSections = useMemo(() => {
    const query = menuSearch
      .trim()
      .toLowerCase();

    if (!query) {
      return navigationSections;
    }

    return navigationSections
      .map((section) => ({
        ...section,
        items: section.items.filter(
          (key) =>
            menuLookup[key]?.label
              ?.toLowerCase()
              .includes(query)
        ),
      }))
      .filter(
        (section) =>
          section.items.length > 0
      );
  }, [menuSearch, menuLookup]);

  const activeTitle =
    selectedUser
      ? "User Details"
      : menuLookup[activePage]?.label ||
        "Dashboard";

  const fetchAcademicYears = async () => {
    setAcademyYearRefreshing(true);

    try {
      window.dispatchEvent(
        new Event(
          "academicYearUpdated"
        )
      );

      window.dispatchEvent(
        new Event(
          "academic-year-updated"
        )
      );
    } finally {
      setTimeout(() => {
        setAcademyYearRefreshing(false);
      }, 400);
    }
  };

  const renderPage = () => {
    if (selectedUser) {
      return (
        <UserDetailsPage
          theme={theme}
          selectedUser={selectedUser}
        />
      );
    }

    switch (activePage) {
      case "payroll":
        return <Payroll theme={theme} />;

      case "dailytransaction":
        return (
          <DailyPaymentTransaction
            theme={theme}
          />
        );

      case "studentpaymentistory":
        return (
          <StudentPaymentHistory
            theme={theme}
          />
        );

      case "incomestatement":
        return (
          <IncomeStatement
            theme={theme}
          />
        );

      case "systemusers":
        return (
          <AddStudentsStaff
            theme={theme}
          />
        );

      case "studentsadmission":
        return (
          <AdmissionForm
            theme={theme}
          />
        );

      case "admissionlist":
        return (
          <StudentAdmission
            theme={theme}
          />
        );

      case "gradedistribution":
        return (
          <GradeDistribution
            theme={theme}
          />
        );

      case "promotion":
        return (
          <PromotionDashboard
            theme={theme}
          />
        );

      case "studentscertificate":
        return (
          <CertificateDashboard
            theme={theme}
          />
        );

      case "studentsidcards":
        return (
          <StudentsIDCard
            theme={theme}
          />
        );

      case "complaintunit":
        return (
          <ComplaintUnit
            theme={theme}
          />
        );

      case "teacherdata":
        return (
          <TeacherDataForm
            theme={theme}
          />
        );

      case "viewlessonplan":
        return (
          <ViewLessonPlan
            theme={theme}
          />
        );

      case "supportstaff":
        return (
          <SupportStaff
            theme={theme}
          />
        );

      case "testprint":
        return (
          <TestPraint
            theme={theme}
          />
        );

      case "printtestbyclass":
        return (
          <PrintTestByClass
            theme={theme}
          />
        );

      case "schoolarchivedashboard":
        return (
          <SchoolArchiveDashboard
            theme={theme}
          />
        );

      case "getteachernotes":
        return (
          <GetStudentNotes
            theme={theme}
          />
        );

      case "testattachmentview":
        return (
          <TestAttachmentView
            theme={theme}
          />
        );

      case "attendancerecord":
        return (
          <AttendanceRecord
            theme={theme}
          />
        );

      case "attendancedata":
        return (
          <AttendanceData
            theme={theme}
          />
        );

      case "statusrecord":
        return (
          <StudentStatusSummary
            theme={theme}
          />
        );

      case "financedashboard":
        return (
          <FinanceDashboard
            theme={theme}
          />
        );

      case "highaverages":
        return (
          <HighAveragesPage
            theme={theme}
          />
        );

      case "topstudents":
        return (
          <TopStudentPerPeriod
            theme={theme}
          />
        );

      case "classviewlist":
        return (
          <ClassViewList
            theme={theme}
          />
        );

      case "subjectviewlist":
        return (
          <ViewCourses
            theme={theme}
          />
        );

      case "approvedlearningcourse":
        return (
          <ApprovedLearningCourse
            theme={theme}
          />
        );

      case "periodicreport":
        return (
          <PeriodReport
            theme={theme}
          />
        );

      case "reportcard":
        return (
          <ReportCard
            theme={theme}
          />
        );

      case "studentsassignments":
        return (
          <AssignmentView
            theme={theme}
          />
        );

      case "studentsnotes":
        return (
          <GetStudentNotes
            theme={theme}
          />
        );

      case "feesrecord":
        return (
          <FinancialPaymentRecord
            theme={theme}
          />
        );

      case "feesrecordanalysics":
        return (
          <SchoolFinancialReport
            theme={theme}
          />
        );

      case "newexpenditure":
        return (
          <DashboardForExpenditure
            theme={theme}
          />
        );

      case "feesallocation":
        return (
          <OtherFee
            theme={theme}
          />
        );

      case "cleararrears":
        return (
          <PaymentRecord
            theme={theme}
          />
        );

      case "classfees":
        return (
          <SchoolFeesData
            theme={theme}
          />
        );

      case "schoolfeedatachart":
        return (
          <SchoolFeeDataChart
            theme={theme}
          />
        );

      case "otherfees":
        return (
          <OtherFeesPayment
            theme={theme}
          />
        );

      case "monthlyrecords":
        return (
          <MonthlyFinancialRecord
            theme={theme}
          />
        );

      case "newblacklist":
        return (
          <NewBlackList
            theme={theme}
          />
        );

      case "loan":
        return <Loan theme={theme} />;

      case "bulkgrades":
        return (
          <BulkTestScorePage
            theme={theme}
          />
        );

      case "teacherattendancescanner":
        return (
          <TeacherAttendanceScanner
            theme={theme}
          />
        );

      case "teachersmartattendancedashboard":
        return (
          <TeacherSmartAttendanceDashboard
            theme={theme}
          />
        );

      case "teachersmartcardmanagement":
        return (
          <TeacherSmartCardManagement
            theme={theme}
          />
        );

      case "teacherscannerdevicemanagement":
        return (
          <TeacherScannerDeviceManagement
            theme={theme}
          />
        );

      case "curriculumadminupload":
        return (
          <CurriculumAdminUpload
            theme={theme}
          />
        );

      default:
        return <Overview theme={theme} />;
    }
  };

  const handleNavigation = (key) => {
    if (isNavigating) {
      return;
    }

    if (
      key === activePage &&
      !selectedUser
    ) {
      if (isMobile) {
        setDrawerOpen(false);
      }

      return;
    }

    setPendingPage(key);
    setIsNavigating(true);
    setSelectedUser(null);
    setMenuSearch("");

    if (isMobile) {
      setDrawerOpen(false);
    }

    window.setTimeout(() => {
      setActivePage(key);
      setPendingPage(null);
      setIsNavigating(false);
    }, 2000);
  };

  const renderNavigationItem = (item) => {
    const active =
      activePage === item.key &&
      !selectedUser;

    return (
      <Tooltip
        key={item.key}
        title={
          collapsed
            ? item.label
            : ""
        }
        placement="right"
      >
        <button
          type="button"
          className={[
            "college-nav-item",
            active
              ? "active"
              : "",
            collapsed
              ? "college-collapsed-item"
              : "",
          ].join(" ")}
          onClick={() =>
            handleNavigation(
              item.key
            )
          }
          disabled={isNavigating}
          aria-current={
            active
              ? "page"
              : undefined
          }
        >
          <span className="college-nav-icon">
            {item.icon}
          </span>

          <span className="college-nav-label">
            {item.label}
          </span>

          <span className="college-nav-chevron">
            <span
              style={{
                display: "flex",
                fontSize: 9,
              }}
            >
              ›
            </span>
          </span>
        </button>
      </Tooltip>
    );
  };

  const sidebar = (
    <div className="college-sidebar-shell">
      <div className="college-sidebar-content">
        <div
          style={{
            height: "100%",
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            background: "transparent",
          }}
        >
          <div
            style={{
              height: 72,
              minHeight: 72,
              display: "flex",
              alignItems: "center",
              justifyContent: collapsed
                ? "center"
                : "flex-start",
              gap: 11,
              padding: collapsed
                ? "0 10px"
                : "0 18px",
              borderBottom: darkMode
                ? "1px solid rgba(99,197,230,.10)"
                : "1px solid rgba(99,197,230,.12)",
            }}
          >
            <div
              style={{
                width: 38,
                height: 38,
                minWidth: 38,
                borderRadius: 8,
                padding: 2,
                background: "#FFFFFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                border:
                  "1px solid rgba(99,197,230,.30)",
                boxShadow:
                  "0 4px 14px rgba(0,0,0,.25)",
              }}
            >
              <img
                src={logo}
                alt="CAYEP logo"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 6,
                  display: "block",
                }}
              />
            </div>

            {!collapsed && (
              <div
                style={{
                  minWidth: 0,
                }}
              >
                <div
                  style={{
                    color: "#F4F9FB",
                    fontSize: 13,
                    fontWeight: 800,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    letterSpacing: ".15px",
                  }}
                >
                  CAYEP
                </div>

                <div
                  style={{
                    marginTop: 3,
                    color: "#63C5E6",
                    fontSize: 8,
                    fontWeight: 800,
                    letterSpacing: 1.05,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  LEADERSHIP TRAINING
                </div>
              </div>
            )}
          </div>

          {!collapsed && (
            <div
              className="college-sidebar-search"
              style={{
                padding:
                  "13px 12px 6px",
                flexShrink: 0,
              }}
            >
              <Input
                allowClear
                value={menuSearch}
                onChange={(event) =>
                  setMenuSearch(
                    event.target.value
                  )
                }
                placeholder="Find a module..."
                prefix={
                  <SearchOutlined
                    style={{
                      color:
                        COLORS.sidebarBright,
                    }}
                  />
                }
              />
            </div>
          )}

          <div
            className="college-sidebar-scroll"
            style={{
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden",
              paddingBottom: 20,
            }}
          >
            {filteredSections.length ===
              0 && (
              <div
                style={{
                  padding:
                    "35px 20px",
                  textAlign: "center",
                  color: "#78939E",
                  fontSize: 11,
                }}
              >
                No module found
              </div>
            )}

            {filteredSections.map(
              (section) => {
                const items =
                  section.items
                    .map(
                      (key) =>
                        menuLookup[key]
                    )
                    .filter(Boolean);

                if (!items.length) {
                  return null;
                }

                return (
                  <div
                    key={section.key}
                  >
                    {!collapsed ? (
                      <div className="college-section-title">
                        {section.title}
                      </div>
                    ) : (
                      <div
                        style={{
                          height: 12,
                        }}
                      />
                    )}

                    {items.map(
                      renderNavigationItem
                    )}
                  </div>
                );
              }
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={
        darkMode
          ? "college-dark"
          : ""
      }
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 999,
        overflow: "hidden",
        background:
          theme.background,
      }}
    >
      <Layout
        style={{
          height: "100vh",
          minHeight: "100vh",
          background:
            theme.background,
        }}
      >
        {!isMobile && (
          <Sider
            width={292}
            collapsedWidth={78}
            collapsed={collapsed}
            trigger={null}
            style={{
              position: "fixed",
              top: 0,
              bottom: 0,
              left: 0,
              height: "100vh",
              zIndex: 100,
              overflow: "hidden",
              background:
                COLORS.sidebar,
            }}
          >
            {sidebar}
          </Sider>
        )}

        {isMobile && (
          <Drawer
            open={drawerOpen}
            placement="left"
            width={310}
            closable={false}
            onClose={() =>
              setDrawerOpen(false)
            }
            styles={{
              body: {
                padding: 0,
                background:
                  COLORS.sidebar,
              },
            }}
          >
            <div
              style={{
                position:
                  "absolute",
                top: 13,
                right: 13,
                zIndex: 20,
              }}
            >
              <Button
                type="text"
                icon={
                  <CloseOutlined />
                }
                onClick={() =>
                  setDrawerOpen(false)
                }
                style={{
                  width: 34,
                  height: 34,
                  color: "#D9E7EC",
                  background:
                    "rgba(99,197,230,.10)",
                  border:
                    "1px solid rgba(99,197,230,.15)",
                  borderRadius: 8,
                  display: "flex",
                  alignItems:
                    "center",
                  justifyContent:
                    "center",
                }}
              />
            </div>

            {sidebar}
          </Drawer>
        )}

        <Layout
          style={{
            marginLeft: isMobile
              ? 0
              : collapsed
                ? 78
                : 292,
            height: "100vh",
            minHeight: "100vh",
            background:
              theme.background,
            transition:
              "margin-left 180ms ease",
          }}
        >
          <Header
            style={{
              height: 68,
              minHeight: 68,
              flexShrink: 0,
              padding: isMobile
                ? "0 9px"
                : "0 16px",
              display: "flex",
              alignItems: "center",
              gap: isMobile ? 6 : 10,
              background:
                theme.header,
              borderBottom:
                `1px solid ${theme.border}`,
              position: "relative",
              zIndex: 30,
            }}
          >
            {isNavigating && (
              <>
                <div className="college-navigation-progress" />

                <div className="college-loading-label">
                  Opening{" "}
                  {menuLookup[
                    pendingPage
                  ]?.label || "module"}
                </div>
              </>
            )}

            <Button
              type="text"
              className="college-menu-button"
              icon={
                isMobile ? (
                  <MenuUnfoldOutlined />
                ) : collapsed ? (
                  <MenuUnfoldOutlined />
                ) : (
                  <MenuFoldOutlined />
                )
              }
              onClick={() => {
                if (isMobile) {
                  setDrawerOpen(true);
                } else {
                  setCollapsed(
                    (value) =>
                      !value
                  );
                }
              }}
            />

            <div
              className="college-search-box"
              style={{
                flex: 1,
                minWidth: 0,
                maxWidth: isMobile
                  ? 270
                  : 450,
              }}
            >
              <UserSearchBox
                theme={theme}
                setSelectedUser={
                  setSelectedUser
                }
                setActiveComponent={
                  setActivePage
                }
              />
            </div>

            <div
              style={{
                flex: 1,
                minWidth: 0,
              }}
            />

            <Tooltip title="Add Academic Year">
              <button
                type="button"
                className="college-academic-year"
                onClick={() =>
                  setOpenAcademyYear(
                    true
                  )
                }
                disabled={
                  academyYearRefreshing
                }
              >
                <PlusOutlined />

                <span className="college-academic-year-text">
                  Add Academic Year
                </span>
              </button>
            </Tooltip>

            <Tooltip title="Tasks">
              <button
                type="button"
                className="college-header-action"
                onClick={() =>
                  setTodoOpen(true)
                }
              >
                <CheckSquareOutlined />
              </button>
            </Tooltip>

            <PostTodoList
              open={todoOpen}
              setOpen={setTodoOpen}
            />

            <Darkmode
              darkMode={darkMode}
              setDarkMode={
                setDarkMode
              }
            />

            {!isMobile && (
              <>
                <NotificationIcon
                  theme={theme}
                />

                <Notice />
              </>
            )}

            <Tooltip title="Profile">
              <div className="college-profile-container">
                <div className="college-profile-avatar">
                  <ProfileImage
                    theme={theme}
                    header
                  />
                </div>
              </div>
            </Tooltip>
          </Header>

          <Content
            style={{
              background:
                theme.background,
              padding: isMobile
                ? "9px 8px 12px"
                : "14px 16px 18px",
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <div className="college-page-heading">
              <div className="college-page-heading-left">
                <span className="college-page-heading-line" />

                <span className="college-page-heading-title">
                  {activeTitle}
                </span>
              </div>

              {!isMobile && (
                <span className="college-page-heading-meta">
                  CAYEP • LEADERSHIP TRAINING - Design by Polu
                </span>
              )}
            </div>

            <motion.div
              key={
                selectedUser
                  ? "user-details"
                  : activePage
              }
              initial={{
                opacity: 0,
                y: 6,
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                duration: 0.2,
                ease: "easeOut",
              }}
              className={
                darkMode
                  ? "college-workspace college-workspace-dark"
                  : "college-workspace"
              }
              style={{
                padding: isMobile
                  ? 9
                  : 15,
              }}
            >
              {renderPage()}
            </motion.div>
          </Content>
        </Layout>
      </Layout>

      <AddAcademyYear
        open={openAcademyYear}
        handleClose={() =>
          setOpenAcademyYear(false)
        }
        refreshYears={
          fetchAcademicYears
        }
      />
    </div>
  );
};

export default NewAdminDashboard;